import { render, staticRenderFns } from "./ChipButtons.vue?vue&type=template&id=3b3b97e6"
var script = {}
import style0 from "./ChipButtons.vue?vue&type=style&index=0&id=3b3b97e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports